import { createSelector, createFeatureSelector } from '@ngrx/store';

import { ProductionState } from '../../models/production.model';

export const getProductionState = createFeatureSelector<ProductionState>('production');

export const getCowList = createSelector(
  getProductionState,
  (state: ProductionState) => state?.cowList,
);

export const getProductionSummary = createSelector(
  getProductionState,
  (state: ProductionState) => state?.productionSummary,
);

export const getAttentionSummary = createSelector(
  getProductionState,
  (state: ProductionState) => state?.attentionSummary,
);
